export class ProcessHttpActionSettings {
    static $inject = ['init'];
    constructor(init) {
        this.headers = {};
        Object.assign(this, init);
    }
}
